module.exports = __webpack_public_path__ + "static/media/g-4-b.2c9639b9.jpg";